import { useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useToast } from "../../context/ToastContext";
import { getErrorMessage } from "../../api/client";
import * as authApi from "../../api/auth";
import { Input } from "../../components/ui/Input";
import { Button } from "../../components/ui/Button";
import { Logo } from "../../components/ui/Logo";

interface ForgotPasswordForm {
  email: string;
}

export default function ForgotPassword() {
  const { showToast } = useToast();
  const [sent, setSent] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<ForgotPasswordForm>();

  const onSubmit = handleSubmit(async ({ email }) => {
    try {
      await authApi.forgotPassword(email);
      // Il backend risponde sempre allo stesso modo, che l'email esista o
      // no — qui mostriamo lo stesso messaggio generico per lo stesso
      // motivo, non c'è nulla da distinguere lato UI.
      setSent(true);
    } catch (err) {
      showToast(getErrorMessage(err, "Richiesta non riuscita. Riprova."), "error");
    }
  });

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4">
      <div className="w-full max-w-sm rounded-card bg-white p-8 shadow-card">
        <div className="mb-8 text-center">
          <Logo className="mx-auto w-44" />
          <p className="mt-2 text-sm text-ink/50">Recupera l'accesso al tuo account</p>
        </div>

        {sent ? (
          <div className="flex flex-col gap-4 text-center">
            <p className="text-sm text-ink">
              Se l'indirizzo email è registrato, riceverai a breve un link per reimpostare la password. Controlla
              anche la cartella spam.
            </p>
            <Link to="/login" className="text-sm font-semibold text-primary hover:underline">
              Torna al login
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
            <p className="text-sm text-ink/60">
              Inserisci l'email con cui accedi — ti mandiamo un link per scegliere una nuova password.
            </p>
            <Input
              label="Email"
              type="email"
              autoComplete="username"
              required
              error={errors.email?.message}
              {...register("email", { required: "L'email è obbligatoria." })}
            />
            <Button type="submit" loading={isSubmitting} className="mt-2 w-full">
              Invia link di recupero
            </Button>
            <Link to="/login" className="text-center text-sm text-ink/50 hover:text-ink">
              Torna al login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
